module.exports = __webpack_public_path__ + "static/media/Avatars_Male-11.4abaf443.png";